import {
  GraphsFbAndIg,
  InsightQueryIgResponse,
  QueryIgComment,
} from "../types/campaigns";
import { ENV } from "../utils/constants";
import { translateStatusSocialNetworks } from "../utils/format";
import api from "./api";

export const getMetricsInstagram = async () => {
  const response = await api.get(`/advertising-dashboard-${ENV}/metrics/instagram`);
  return response?.data?.content;
};

export const getStatusInstagram = async (
  campaign_id: string | number
)  => {
  const content = await api.post(
    `/social-networks-v2-${ENV}/insights/instagram`,
    { campaign_id }
  );

  const contentResponse = content.data?.content;

  console.log("comments_count", contentResponse.insights.comments_count);

  if (contentResponse.insights.comments_count > 0) {
    await api.post(`/social-networks-v2-${ENV}/comments/instagram`, {
      campaign_id,
    });
  }

  delete contentResponse.insights.post_id_fk;
  delete contentResponse.insights.impressions;

  const status = Object.entries(contentResponse.insights).map((value) => ({
    quantidade: value[1],
    status_envio_externo: translateStatusSocialNetworks(value[0]),
  }));
  return status;
};

export const getGraphsInstagramCommentsData = async (): Promise<
  GraphsFbAndIg[]
> => {
  const params = {};

  const { data } = await api.get(
    `/advertising-dashboard-${ENV}/metrics/count/instagram-comments`,
    { params }
  );

  return data?.content;
};

export const getGraphsInstagramEngajamentData = async (): Promise<
  GraphsFbAndIg[]
> => {
  const params = {};

  const { data } = await api.get(
    `/advertising-dashboard-${ENV}/metrics/count/instagram-engajament`,
    { params }
  );

  return data?.content;
};

export const getGraphsInstagramImpressionsData = async (): Promise<
  GraphsFbAndIg[]
> => {
  const params = {};

  const { data } = await api.get(
    `/advertising-dashboard-${ENV}/metrics/count/instagram-impressions`,
    { params }
  );

  return data?.content;
};

export const getGraphsInstagramLikesData = async (): Promise<
  GraphsFbAndIg[]
> => {
  const params = {};

  const { data } = await api.get(
    `/advertising-dashboard-${ENV}/metrics/count/instagram-likes`,
    { params }
  );

  return data?.content;
};

export const getGraphsInstagramViewsData = async (): Promise<
  GraphsFbAndIg[]
> => {
  const params = {};

  const { data } = await api.get(
    `/advertising-dashboard-${ENV}/metrics/count/instagram-views`,
    { params }
  );

  return data?.content;
};

export const getPerformanceInstagram = async (
  campaign_id: string | number
): Promise<InsightQueryIgResponse | any> => {
  const { data } = await api.post(
    `/social-networks-v2-${ENV}/insights/instagram`,
    { campaign_id }
  );

  return data?.content;
};

export const getCommentsInstagram = async (
  campaign_id: string | number
): Promise<QueryIgComment> => {
  const { data } = await api.post(
    `/social-networks-v2-${ENV}/comments/instagram`,
    { campaign_id }
  );

  return data?.content;
};
